export class RecyclingFolderPriceReport {
  constructor(
    storeBoomerangId,
    totalPrice
  ) {
    this.storeBoomerangId = storeBoomerangId
    this.totalPrice = totalPrice
  }
}
